// Single source of truth for Brella backend base URLs (customer portal).
//
// Both bases point at the customer edge (api.brella.ai); the Cloudflare edge
// worker fans out by path to the owning backend (chat → AWS box, protect →
// its origin), so the portal doesn't care where either backend physically
// runs. The worker forces Access-Control-Allow-Origin:* on every response, so
// the cross-origin call from the App-Proxy-served portal is fine.
//
// History: previously hardcoded the Heroku chatbot/protect origins. Repointed
// to the edge during the Heroku→AWS migration (2026-06-22) so decommissioning
// Heroku doesn't break the portal, and so the Phase-2 protect move is
// transparent here (no further change needed).
//
// Override per environment with REACT_APP_* env vars.
export const CHAT_API_BASE =
  process.env.REACT_APP_CHAT_API_BASE || 'https://api.brella.ai';

export const PROTECT_API_BASE =
  process.env.REACT_APP_PROTECT_API_BASE || 'https://api.brella.ai';
